import{i as a}from"./chunk-FC3CZOOQ.js";import{j as t,m as s}from"./chunk-HBP5N4FR.js";s();import o from"axios";function f(r){return t(this,null,function*(){let{data:e}=yield o.get(`${r}/${a}?size=1&fields=hash,timestamp`),[i]=e;return i})}export{f as a};
//# sourceMappingURL=chunk-XZ2PVEHF.js.map
